import {Injectable} from '@angular/core';
import {AuthService} from "./auth.service";
import {
  APIResponse,
  IncidentRecord,
  IncidentSaveEditReq,
  LabInfo,
  PendingChangeList,
  ReportRecord
} from "../NIBINInterface";
import axios from "axios";
import {MatSnackBar} from "@angular/material/snack-bar";
import Swal from "sweetalert2";

@Injectable()
export class DataChangeRequestService {
  constructor(private authService:AuthService, private matSnackBar: MatSnackBar) {}

  public async GetPendingChangeCount(lab: string) : Promise<APIResponse> {
    try{
      let result = await axios.get('/NIBIN/DataChangeRequest/GetPendingChangeCount?Lab='+lab,{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Get Pending Changes Review Count",
        timerProgressBar:true,
        timer:3000
      })

      return {MessageCode:600, AnyData:0}
    }
  }
  public async ChangeLab(IncidentID:string, newlab: string, reason:string) : Promise<APIResponse> {
    try{
      let result = await axios.post('/NIBIN/DataChangeRequest/ChangeLab',{
        IncidentID: IncidentID,
        NewLab: newlab,
        TransferReason: reason
      },{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Submit Lab Ownership Transfer Request",
        timerProgressBar:true,
        timer:3000
      })

      return {MessageCode:600, AnyData:0}
    }
  }

  public async GetPendingEditsList(lab: string) : Promise<any> {
    try{
      let result = await axios.get('/NIBIN/DataChangeRequest/GetPendingEditsList?Lab='+lab,{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Get Pending Edit List",
        timerProgressBar:true,
        timer:3000
      })

      return {MessageCode:600, AnyData:0}
    }
  }

  public async GetPendingChangesList(lab: string) : Promise<APIResponse> {
    try{
      let result = await axios.get('/NIBIN/DataChangeRequest/GetPendingChangesList?Lab='+lab,{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Get Pending Changes List",
        timerProgressBar:true,
        timer:3000
      })

      return {MessageCode:600, AnyData:0}
    }
  }
  public async GetChangeHistoryList(lab: string, approved:boolean) : Promise<APIResponse> {
    try{
      let result = await axios.get('/NIBIN/DataChangeRequest/GetChangesHistoryList?Lab='+lab+'&QueryType='+approved,{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Get Change History List",
        timerProgressBar:true,
        timer:3000
      })

      return {MessageCode:600, AnyData:0}
    }
  }
  public async ProcessChangeRequest(ChangeID: string, Approved:boolean) : Promise<APIResponse> {
    try{
      let result = await axios.get('/NIBIN/DataChangeRequest/ProcessChangeRequest?ChangeID='+ChangeID+'&approved='+Approved,{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Process Change Request",
        timerProgressBar:true,
        timer:3000
      })

      return {MessageCode:600, AnyData:0}
    }
  }
  public parseChangeList(list:any) : PendingChangeList[] {
    let result:PendingChangeList[] = [];
    let processedList:string[] = []

    if(list){
      for(let l of list){
        if(processedList.includes(l.ChangeID)){
          let index = result.map(e => e.ChangeID).indexOf(l.ChangeID);
          if(index<=0){
            result[index].Changes?.push({
              IncidentID: l.IncidentID,
              Property: l.DB_COL,
              OldValue: l.DB_OldVal,
              NewValue: l.DB_NewVal
            })
          }
        }
        else{
          processedList.push(l.ChangeID)
          let temp: PendingChangeList = <PendingChangeList>{};
          temp.ChangeID = l.ChangeID
          temp.ItemID = l.DB_RowID
          temp.ItemType = l.DB_TBL
          temp.ReqDateTime = l.ReqDateTime
          temp.ReqLab = l.ReqLab
          temp.AssignedLab = l.AssignedLab
          temp.Changes = []
          temp.Changes?.push({
            IncidentID: l.IncidentID,
            Property: l.DB_COL,
            OldValue: l.DB_OldVal,
            NewValue: l.DB_NewVal,
            ChangeReason: l.ChangeReason
          })
          result.push(temp)
        }
      }
    }
    return result;
  }

  public async getSharedEditLink(IncidentID: string, email: any) : Promise<any>{
    try{
      let result = await axios.post('/NIBIN/DataEntryRequests/createSharedRequest?incidentID='+IncidentID,email,{ headers:{authToken:this.authService.getUser().apikey}})
      Swal.fire({
        icon: 'success',
        title: 'System Notification',
        text: "Email Successfully Sent",
        timerProgressBar:true,
        timer:4000
      })
      return result.data;
    }
    catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: "Error Trying to Process Share Link Request",
        timerProgressBar:true,
        timer:3000
      })

      return {MessageCode:600, AnyData:0}
    }
  }
  public async getSharedEditToken(hID: string): Promise<string | null>{
    try{
      let result = await axios.get('/NIBIN/DataEntryRequests/SharedAuthentication?hID='+hID,{ headers:{}})
      return result.data;
    }
    catch (e) {
      return null
    }
  }

  public async getSharedEditIncident(hID: string, SharedEditToken: string): Promise<IncidentRecord | null>{
    try{
      let result = await axios.get('/NIBIN/DataEntryRequests/loadSharedRequestIncident?hID='+hID,{ headers:{authToken:SharedEditToken}})
      return result.data;
    }
    catch (e) {
      return null
    }
  }

  public async saveSharedEditIncident(hID: string, IncSaveObj: IncidentSaveEditReq,SharedEditToken: string): Promise<IncidentRecord | null>{
    try{
      let result = await axios.post('/NIBIN/DataEntryRequests/IncidentSaveEditReq?hID='+hID,IncSaveObj,{ headers:{authToken:SharedEditToken}})
      return result.data;
    }
    catch (e) {
      return null
    }
  }

  public async  GetPendingIncidentRecord(IncidentID: string, BatchID: string): Promise<IncidentRecord | null>{
    try{
      let result = await axios.get('/NIBIN/DataChangeRequest/viewIncidentChangeRequest?IncidentID='+IncidentID+'&ChangeID='+BatchID,{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      return null
    }

  }
  public async  MarkPendingEditsAsComplete(IncidentID: string | null, BatchID: string | null): Promise<IncidentRecord | null>{
    try{
      let result = await axios.post('/NIBIN/DataChangeRequest/MarkPendingEditsAsComplete?ChangeID='+BatchID,{},{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      return null
    }

  }

  public async  MarkPendingEditsAsRejected(IncidentID: string | null, BatchID: string | null): Promise<IncidentRecord | null>{
    try{
      let result = await axios.post('/NIBIN/DataChangeRequest/MarkPendingEditsAsRejected?ChangeID='+BatchID,{},{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      return null
    }

  }

  public async  GetLatestReportForBatch(IncidentID: string | null): Promise<ReportRecord | null>{
    try{
      let result = await axios.get('/NIBIN/DataEntryRequests/GetLatestReportForBatch?IncidentID='+IncidentID,{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      return null
    }

  }

  public async  GetEmailForBatchNotification(BatchID: string | null): Promise<string[] | null>{
    try{
      let result = await axios.get('/NIBIN/DataEntryRequests/GetEmailForBatchNotification?BatchID='+BatchID,{ headers:{authToken:this.authService.getUser().apikey}})
      return result.data;
    }
    catch (e) {
      return null
    }
  }

}
